// Gandalf's own route handlers (src/app/services/api/*).
export const BFF_API_URL = {
  search: '/services/api/search',
  vivianTracking: '/services/api/tracking/vivian',
  reviews: (productSku: string, store: string) =>
    `/services/api/reviews/${productSku}/${store}`,
  submitReview: (sku: string) => `/services/api/reviews/${sku}`,
  productData: '/services/api/product',
  productVideo: '/services/api/product/video',
};

export const YVES_API_URL = {
  menu: '/api/menu',
  login: '/api/customer/login',
  logout: '/api/customer/logout',
  userInfo: '/api/customer/info',
  lastPurchased: '/api/customer/last-purchased',
  search: '/api/search',
  searchPreview: '/api/catalog/search-preview',
  productsList: '/api/catalog/products',
  sponsoredProducts: '/api/catalog/sponsored-products',
  relatedProducts: (sku: string) => `/api/catalog/related-products/${sku}`,
  productInsurance: (sku: string) => `/api/catalog/products/${sku}/insurance`,
  paymentMethod: '/api/payment-method',
  cart: '/api/cart',
  continueToCheckout: '/api/cart?r=co',
  addItemToCart: '/api/cart/add',
  updateCartItemQuantity: (sku: string) =>
    `/api/cart/items/${sku}/update-quantity`,
  removeCartItem: (sku: string) => `/api/cart/items/${sku}/remove`,
  addVoucherCode: '/api/cart/coupon/add',
  removeVoucherCode: '/api/cart/coupon/clear',
  addInsuranceToCart: '/api/cart/insurance/add',
  removeInsuranceFromCart: '/api/cart/insurance/remove',
  pageMetaData: '/api/tracking/page-metadata',
  vivianTracking: '/api/tracking/vivian',
  shoppingList: '/api/shopping-list',
  createShoppingList: '/api/shopping-list/create',
  addItemsToShoppingList: (hash: string) =>
    `/api/shopping-list/${hash}/items/add-items`,
  removeItemFromShoppingList: (hash: string) =>
    `/api/shopping-list/${hash}/items/remove-item`,
  addItemToDefaultShoppingList: '/api/shopping-list-default/items/add-item',
  bulkUpdateShoppingListItems: '/api/shopping-list/items/bulk-update',
  reviewConfig: (orderNumber: string, sku: string, customerNumber: string) =>
    `/api/reviews/${orderNumber}/${sku}/${customerNumber}`,
  productImpression: '/vivian/event',
  sponsoredProductsImpression: '/sp/impression',
  paypalExpressPreAuth: '/paypalexpress/pre-authorization?pm=ppi',
  paypalExpressFetchCustomerDetails:
    '/paypalexpress/fetch-customer-details?pm=ppe',
};

export const DEXTER_API_URL = {
  evaluate: '/api/v1/evaluate',
  previewResolve: '/api/admin/preview/resolve',
};

export const ORDERIX_API_URL = {
  lastPurchaseBySku: (
    countryCode: string,
    customerNumber: string,
    sku: string,
  ) => `/api/list/${countryCode.toUpperCase()}/${customerNumber}/${sku}`,
};

export const REVIEW_HUB_API_URL = {
  reviews: (sku: string, store: string, baseUrl: string) =>
    new URL(
      `/${encodeURIComponent(sku)}/reviews/${encodeURIComponent(store)}`,
      baseUrl,
    ).toString(),
  submitReview: (sku: string, baseUrl: string) =>
    new URL(`/${encodeURIComponent(sku)}/reviews`, baseUrl).toString(),
};
export const LUMBERJACKID_KEY = 'x-Lumberjackid';
export const PHPSESSID_COOKIE_KEY = 'PHPSESSID';
